<template>
<div id="allmembers">
     <v-dialog
      v-model="loading_"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title><h4>{{$t('dashboard._Valid_members_')}}: {{this.users.length}}</h4></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        right
        append-icon="search"
        label="Recherche"
        single-linef
        hide-details
      ></v-text-field>
      <v-btn icon>
        <v-icon>more_vert</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>

    <v-card-text class="pa-0">

     <div class="btn-group center">
  <v-btn color="success" @click="refresh()"  ><v-icon>refresh</v-icon></v-btn> 
<download-excel
          class   = "btn btn-default"
          :data   = "users_payment_true"
          :fields = "json_fields_2"
          type    = "xls"
          name    = "all_users_payment_true.xls">
          <button type="button" class="mb-2 v-btn theme--dark warning">Paid
        </button> 
        
        </download-excel>
       <download-excel
      class   = "btn btn-default"
      :data   = "users_payment_false"
      :fields = "json_fields_2"
      type    = "xls"
      name    = "all_users_ecc_payment_false.xls">
      <button type="button" class="mb-2 v-btn theme--dark danger">No Payment
    </button> 
    
    </download-excel>
      
      <v-btn class="ma-2" color="indigo"   @click="download_image_qr_uuid_all" v-show="selected.length>0" dark> 
             <v-icon>cloud_download</v-icon>
             </v-btn>
        <v-btn class="ma-2" color="error"   @click="delete_all" v-show="selected.length>0" dark>  
          <v-icon>delete</v-icon>
          </v-btn>

      <download-excel
      v-show="specific_select.length>0"
	class   = "btn btn-default"
	:data   = "specific_select"
	:fields = "json_fields"
  type    = "xls"
	name    = "specific_users_ecc.xls">
  <button type="button" id = "specific_xls" ref="specific_xls" class="mb-2 v-btn theme--dark primary">
</button> 
 
</download-excel>
</div>
 <b>{{waiting}} </b>

      <img id="myImg" src="" /> 
      <template>
 <!-- <download-excel
	class   = "btn btn-default"
	:data   = "users"
	:fields = "json_fields"
  type    = "xls"
	name    = "all_users.xls">
  <button type="button" class="mb-2 v-btn theme--dark primary">{{'general._ExporttoCSV_'|translate}}
</button> 
 
</download-excel>  -->
 <!-- {{selected}} -->
  <input type="checkbox" class="form_checkbox" v-model="selectAll" @click="select"> <b>Select/Unselect All ({{selected.length}})</b>
        <v-data-table
          :headers="headers"
          :items="users"
          class="elevation-0"
          :pagination.sync="pagination"
          :search="search"
          item-key="id">
       
          <template slot="items" slot-scope="props">
            
            <tr class="text-xs-left"  style="cursor: pointer">
            <td class="text-xs-left"> <input  class="form_checkbox" type="checkbox" :value="{id:props.item.uuid,
            qr_url:props.item.qr_url,image_url:props.item.image_url,standard_photo:props.item.standard_photo,payment_made:props.item.payment_made}" v-model="selected"></td>
          
          
            <td class="text-xs-left">    
            <v-btn class="ma-2" color="indigo" @click="download_image_qr_uuid(props.item.uuid)" v-show="show_download_btn(props.item.uuid)" dark>
              <v-icon dark>cloud_download</v-icon>
              </v-btn>
            </td>
         
         
          <td class="text-xs-left">
           <div class="images" v-viewer>
           <v-avatar size="36px">
          <img :src="props.item.image_url"  />
           </v-avatar>
           </div>     
            </td>

            <td class="text-xs-left">
             
            <div class="images" v-viewer>
           <v-avatar size="36px">
            
            <img :src="props.item.standard_photo"  />
             </v-avatar>
            </div>   
            </td> 
           
            <td class="text-xs-left">{{ props.item.card_id }}</td>
            <td class="text-xs-left">{{ props.item.registration_hour }}</td>
            <td class="text-xs-left">{{ props.item.registration_date }}</td>
            <td class="text-xs-left">{{ props.item.first_name }}</td>
            <td class="text-xs-left">{{ props.item.last_name }}</td>   
            <td class="text-xs-left">{{ props.item.payment_made }}</td>
            <td class="text-xs-left">{{ props.item.phone }}</td>
            <td class="text-xs-left">{{ props.item.role }}</td>
            <td class="text-xs-left">{{ props.item.church_name }}</td>
            <td class="text-xs-left">{{ props.item.date_of_birth }}</td>
             <td class="text-xs-left">

                  <div v-viewer class="images clearfix">
              <template >
                <img :src="props.item.qr_url" class="image" >
                </template>
            </div>
             
                </td>
           
            </tr>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
  </v-card>
</div>
</template>

<script>
/* eslint-disable */ 
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
import { storage } from '@/api/firebaseInit';
import _ from "lodash";
export default {
  data () {
    return {
      waiting:'',
      specific_select:[],
       selected: [],
      selectAll: false,
      search: '',
      loading_: false,
      good_togo:false,
        headers: [
          { text:'', value: 'button' },
           { text:'', value: 'first_name' },
          {
            text:this.$t('members._photo_'),
            align: 'left',
            sortable: false,
            value: 'image_url',
            width: "1%"
          },
          {
            text:'Standard photo',
            align: 'left',
            sortable: false,
            value: 'standard_photo',
            width: "10%"
          },
      

          { text:'card_id' , value: 'card_id', width: "95%" },
        
          { text:'registration_hour' , value: 'registration_hour',width: "10%" },
          
          { text:'registration_date' , value: 'registration_date',width: "1%" },
        
          { text:'first_name', value: 'first_name',width: "1%" },
          { text:'last_name', value: 'last_name',width: "1%" },
          { text:'payment_made', value: 'payment_made',width: "1%" },
          { text:this.$t('members._phone_'), value: 'phone' },
           { text:'role' , value: 'role' },
          { text:this.$t('members._churchName_') , value: 'church_name',width: "1%" },
         /*  { text:this.$t('members._email_') , value: 'email' }, */
          { text:this.$t('members._dateofBirth_') , value: 'date_of_birth',width: "1%" },
          { text:this.$t('members._qrcode_'), value: 'qr_url',width: "1%" },
      
        ],
      json_fields_2: {
          'Card_ID':'card_id',
          'First_name': 'first_name',
          'Last_name': 'last_name',
          'Sex': 'gender',
          'Date_of_birth':'date_of_birth',
          'Role': 'role',
          'Registration_date': 'registration_date',   
          'Member_since_date': 'member_since',
          'Qr_name':'qr_name',
          'Standard_photo_name':'image_name',
          'Church_name':'church_name',
          'Payment_made':'payment_made',
          'Amount':'amount',
          'Bar_code':'bar_code'
      },
       //'Qr Code': 'qr_url',
          //'Image': 'standard_photo',
          json_fields: {
          'Card_ID':'card_id',
          'First_name': 'first_name',
          'Last_name': 'last_name',
          'Sex': 'gender',
          'Date_of_birth':'date_of_birth',
          'Role': 'role',  
          'Member_since_date': 'member_since',
          'Qr_name':'qr_name',
          'Standard_photo_name':'image_name',
          'Church_name':'church_name',
          'Payment_made':'payment_made',
          'Amount':'amount',
          'Bar_code':'bar_code'
      },
        pagination: {
          sortBy: 'lastName',
          rowsPerPage: '100'
        },
    };
  },
   computed: {
    users () {
      let users = this.$store.getters.users;
      return _.orderBy(users, ["registration_date"], ["desc"]).slice(0);
    },
    users_payment_true(){
      let users = this.$store.getters.users;
      return users.filter(item => (item.payment_made) === 'true');
    },
       users_payment_false(){
      let users = this.$store.getters.users;
      return users.filter(item => (item.payment_made) === 'false');
    }
  },
  watch: {
    users(val) {
     let users = this.$store.getters.users;
      return users
    },
        users_payment_true(){
      let users = this.$store.getters.users;
      return users.filter(item => (item.payment_made) === 'true');
    },
       users_payment_false(){
      let users = this.$store.getters.users;
      return users.filter(item => (item.payment_made) === 'false');
    }
  },
  methods: {

    show_download_btn (uuid) {

        if(this.selected.length>0) {

            for(var i=0;i<this.selected.length;i++){
    
             if( this.selected[i].id ==uuid ) {
        
                return true;
              }
         }
         return false;
        } else {

          return false;
        }

    },
    dataLoading () {
       let loading = true
       if (this.users.length !=0) {
         loading = false
       }
      return loading;
    },
   async  refresh () {
      this.waiting = "";
      this.waiting = "please wait ...";
      //this.loading_ = true;
      console.log(this.waiting)
      this.$store.dispatch('fetchUsers');
     
      if (this.users.length!=0){
         await this.sleep(1000);
        this.loading_=false;
        this.waiting= ''
         }
     
    },
   download_image_qr (){

this.download_images()
this.download_qrs();

   },


  async download_image_qr_uuid_all (){
console.log('download QR and image 11 ...')
    for(var i=0;i<this.selected.length;i++){
      
      for (let j in this.users) {
      if( this.selected[i].id == this.users[j].uuid ) {
       // if(this.good_togo ==true) {
         await this.sleep(500)

          console.log('download QR and image 222 ...')
         this.download_images_uuid(this.selected[i].id)
          await this.sleep(500)
          this.download_qrs_uuid(this.selected[i].id);
        // }
        }  
    }
    }


  this.prepare_csv()

   },

      delete_all (){

    if (confirm(this.$t('members._confirm_delete_'))) {
    for(var i=0;i<this.selected.length;i++){
      for (let j in this.users) {
      if( this.selected[i].id == this.users[j].uuid ) {
          this.deleteItem(this.selected[i].id);
      
        }  
    }
    }
    }
   },

  download_image_qr_uuid (uuid){

this.download_images_uuid(uuid)
this.download_qrs_uuid(uuid);
this.prepare_csv()
   },
      async  prepare_csv(){
        
    this.specific_select=[];
   
    for(var i=0;i<this.selected.length;i++){
      
      for (let j in this.users) {
     // var code = 187+j
      if( this.selected[i].id == this.users[j].uuid ) {
        // this.users[j].bar_code = this.users[j].bar_code+code
         this.specific_select.push(this.users[j])
         
        }  
    }
    }
      console.log('download xls ...'+this.specific_select.length)
      //this.$refs.specific_xls.click()
       await this.sleep(500)  
       document.getElementById("specific_xls").click();
       await this.sleep(100)
       this.specific_select=[];
       },
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.users) {
          this.selected.push(this.users[i].uuid);
         
        }
      }
    },
    
  download_qrs_uuid : async function(uuid){
      
  
        for(var i=0;i<this.selected.length;i++){
           
             if(this.selected[i].id==uuid) {
                    var storageRef = storage.ref();
                   
                    var url2 = this.selected[i].qr_url
                    var file_name= url2.substring(
                                   url2.lastIndexOf("%2F") + 3, 
                                   url2.lastIndexOf("?")
                                            )
                    var id = this.selected[i].id
                    await this.sleep(500);            
             storageRef.child('media_attachements/'+id+'/qr_code/'+'QR_'+id).getDownloadURL().then(function(url) {
                console.log(url)
                     // This can be downloaded directly:
                    
                      var xhr = new XMLHttpRequest();
                      xhr.responseType = 'blob';
                      
                      xhr.onload = function(event) {
                         
                        var blob = xhr.response;
                         
                          var a = document.createElement('a');

                        a.href = window.URL.createObjectURL(blob);

                        a.download = file_name+".png"; // Name the file anything you'd like.
                        //file_name =""
                        a.style.display = 'none';

                        document.body.appendChild(a);

                        a.click();
                      };
                       //await this.sleep(1000);
                      xhr.open('GET', url);
                      xhr.send();
                      this.good_togo = true
              // Or inserted into an <img> element:
               /*  var img = document.getElementById('myImg');
                img.src = url; */

                        }).catch(function(error) {
                              console.log('eeeeee'+JSON.stringify(error))
                        // Handle any errors

                        });
                
                    console.log(i)
               
    
        }
      } 
    },



 

  download_images_uuid : async function(uuid){
       console.log('image ...'+uuid)
  
        for(var i=0;i<this.selected.length;i++){
           
             if (this.selected[i].id == uuid) {
                    var storageRef = storage.ref();
                   
                    var url2 = this.selected[i].standard_photo
                    file_name =""
                    var file_name= url2.substring(
                                   url2.lastIndexOf("%2F") + 3, 
                                   url2.lastIndexOf("?")
                                            )
                    var folder= new URL(url2).pathname;
                    var id = this.selected[i].id
                    var path = folder.search("kyc_data");     
           
              
                   if( path==-1) {
                        path = 'media_attachements/'+id+'/kyc_picture/'+file_name
                    } else {
                      path ="kyc_data/"+id+'/'+file_name
                    }
                await this.sleep(1000);            
                storageRef.child(path).getDownloadURL().then(function(url) {
                console.log(url)
                     // This can be downloaded directly:
                    
                      var xhr = new XMLHttpRequest();
                      xhr.responseType = 'blob';
                      
                      xhr.onload = function(event) {
                         
                        var blob = xhr.response;
                         
                          var a = document.createElement('a');

                        a.href = window.URL.createObjectURL(blob);
                        
                        
                        a.download = file_name+".jpg"; // Name the file anything you'd like.
                       
                        a.style.display = 'none';

                        document.body.appendChild(a);

                        a.click();
                       this.good_togo = true
                      };
                      
                      xhr.open('GET', url);
                      xhr.send();
                   
                        }).catch(function(error) {
                              console.log('eeeeee'+JSON.stringify(error))
                        // Handle any errors

                        });
                
                    console.log(i)
               
    
        }
       }
    },



    download_images : async function(){
      
  
        for(var i=0;i<this.selected.length;i++){
           
             
                    var storageRef = storage.ref();
                   
                    var url2 = this.selected[i].standard_photo
                    file_name =""
                    var file_name= url2.substring(
                                   url2.lastIndexOf("%2F") + 3, 
                                   url2.lastIndexOf("?")
                                            )
                    console.log('filename'+file_name)
                    var id = this.selected[i].id
                                  await this.sleep(1000);            
                storageRef.child('media_attachements/'+id+'/kyc_picture/'+file_name).getDownloadURL().then(function(url) {
                console.log(url)
                     // This can be downloaded directly:
                    
                      var xhr = new XMLHttpRequest();
                      xhr.responseType = 'blob';
                      
                      xhr.onload = function(event) {
                         
                        var blob = xhr.response;
                         
                          var a = document.createElement('a');

                        a.href = window.URL.createObjectURL(blob);
                        
                        
                        a.download = file_name+".jpg"; // Name the file anything you'd like.
                       
                        a.style.display = 'none';

                        document.body.appendChild(a);

                        a.click();
                       
                      };
                      
                      xhr.open('GET', url);
                      xhr.send();
                   
                        }).catch(function(error) {
                              console.log('eeeeee'+JSON.stringify(error))
                        // Handle any errors

                        });
                
                    console.log(i)
               
    
        }
       
    },

    down2 : async function(){
       for(var i=0;i<3;i++){
            await this.sleep(10);
               if(this.users[i].qr_url != undefined)  {
                    var storageRef = storage.ref();
                    var url = this.users[i].qr_url
                    var file_name= url.substring(
                                   url.lastIndexOf("%2F") + 3, 
                                   url.lastIndexOf("?"));

                  fetch(url,{
                  headers:{
    'Access-Control-Allow-Headers': '*'
  }}
                  )
  .then(res => res.blob()) // Gets the response and returns it as a blob
  .then(blob => {
    // Here's where you get access to the blob
    // And you can use it for whatever you want
    // Like calling ref().put(blob)

    // Here, I use it to make an image appear on the page
    let objectURL = URL.createObjectURL(blob);
    let myImage = new Image();
    myImage.src = objectURL;
    document.getElementById('myImg').appendChild(myImage)
});
                   
               }
       }
    },
           sleep(ms) {

        return new Promise(resolve => setTimeout(resolve, ms));
      },


    // for future use;
    editItem(item) {
      this.$store.commit('currentMemberId', item.id);
       this.fetchCurrentMember(item.id)
      // this.$store.commit('currentMemberId', item.id)
      //   // this.$store.dispatch('fetchCurrentMember', item.id)
      //   this.$router.push('/form/newmember')
      },
    deleteItem(id) {
         const index = this.users.findIndex(x => x.uuid == id )
          this.users.splice(index, 1)
          this.$store.dispatch('deleteUser', id)
         
         this.refresh()
      },

  },
}
</script>

<style>
td {
  width: 150px !important;
}
.image {
  height: 20px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

.right_side_div {
 
    position: relative;
}

.right_side_div button {
    float: right;
    margin-left: -50%;
}

/* Clear floats (clearfix hack) */
.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.btn-group button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}

/* Add a background color on hover */
.btn-group button:hover {
  background-color: #3e8e41;
}

.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}
</style>




// WEBPACK FOOTER //
// src/pages/widgets/AllUsers.vue